"use strict";

exports.__esModule = true;

var _extends3 = require("babel-runtime/helpers/extends");

var _extends4 = _interopRequireDefault(_extends3);

exports.default = extractPropertyFromFields;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extractPropertyFromFields(fields, property) {
  return (fields || []).reduce(function (acc, properties, field) {
    var _extends2;

    return (0, _extends4.default)({}, acc, (_extends2 = {}, _extends2[field] = properties && properties.get(property) || null, _extends2));
  }, {});
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/onion-form/lib/extractPropertyFromFields.js
// module id = 492
// module chunks = 0